import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8402a5c6"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports